/*
 * @Description: 线索管理公共枚举数据字典
 * @Author: mdb
 * @Date: 2022-07-06 14:31:16
 * @LastEditTime: 2022-09-24 15:35:39
 * @LastEditors: mdb
 */

// 线索状态
export const clueStatusEnum = [
  { value: undefined, label: '全部' },
  { value: 3, label: '跟进中', color: '#EF8D3C' },
  { value: 8, label: '已转化', color: '#3FAC46' }
]

// 线索类型
export const clueTypeEnum = [
  { value: 0, label: '新线索' },
  { value: 1, label: '未来线索' },
  { value: 2, label: '有效线索' },
  { value: 3, label: '无效线索' }
]

export default { clueStatusEnum, clueTypeEnum }
